export interface BackgroundJobsFlags {
  geracaoFolhasMensais: boolean;
  emailsPrazoRelatorioAtividades: boolean;
  abrirProcessosSeletivosAgendados: boolean;
  fecharProcessosSeletivosExpirados: boolean;
  limpezaNotificacoesAntigas: boolean;
  limpezaAuditoriaEmailsAntigas: boolean;
  anonimizarCandidatosLgpd: boolean;
}

export const DEFAULT_BACKGROUND_JOBS_FLAGS: BackgroundJobsFlags = {
  geracaoFolhasMensais: true,
  emailsPrazoRelatorioAtividades: true,
  abrirProcessosSeletivosAgendados: true,
  fecharProcessosSeletivosExpirados: true,
  limpezaNotificacoesAntigas: true,
  limpezaAuditoriaEmailsAntigas: true,
  anonimizarCandidatosLgpd: false,
};

export function parseBackgroundJobsFlags(valor: string | undefined): BackgroundJobsFlags {
  if (!valor?.trim()) {
    return { ...DEFAULT_BACKGROUND_JOBS_FLAGS };
  }
  try {
    const parsed = JSON.parse(valor) as Record<string, unknown>;
    return {
      geracaoFolhasMensais:
        typeof parsed.geracaoFolhasMensais === 'boolean'
          ? parsed.geracaoFolhasMensais
          : DEFAULT_BACKGROUND_JOBS_FLAGS.geracaoFolhasMensais,
      emailsPrazoRelatorioAtividades:
        typeof parsed.emailsPrazoRelatorioAtividades === 'boolean'
          ? parsed.emailsPrazoRelatorioAtividades
          : DEFAULT_BACKGROUND_JOBS_FLAGS.emailsPrazoRelatorioAtividades,
      abrirProcessosSeletivosAgendados:
        typeof parsed.abrirProcessosSeletivosAgendados === 'boolean'
          ? parsed.abrirProcessosSeletivosAgendados
          : DEFAULT_BACKGROUND_JOBS_FLAGS.abrirProcessosSeletivosAgendados,
      fecharProcessosSeletivosExpirados:
        typeof parsed.fecharProcessosSeletivosExpirados === 'boolean'
          ? parsed.fecharProcessosSeletivosExpirados
          : DEFAULT_BACKGROUND_JOBS_FLAGS.fecharProcessosSeletivosExpirados,
      limpezaNotificacoesAntigas:
        typeof parsed.limpezaNotificacoesAntigas === 'boolean'
          ? parsed.limpezaNotificacoesAntigas
          : DEFAULT_BACKGROUND_JOBS_FLAGS.limpezaNotificacoesAntigas,
      limpezaAuditoriaEmailsAntigas:
        typeof parsed.limpezaAuditoriaEmailsAntigas === 'boolean'
          ? parsed.limpezaAuditoriaEmailsAntigas
          : DEFAULT_BACKGROUND_JOBS_FLAGS.limpezaAuditoriaEmailsAntigas,
      anonimizarCandidatosLgpd:
        typeof parsed.anonimizarCandidatosLgpd === 'boolean'
          ? parsed.anonimizarCandidatosLgpd
          : DEFAULT_BACKGROUND_JOBS_FLAGS.anonimizarCandidatosLgpd,
    };
  } catch {
    return { ...DEFAULT_BACKGROUND_JOBS_FLAGS };
  }
}

export function serializeBackgroundJobsFlags(flags: BackgroundJobsFlags): string {
  return JSON.stringify({
    geracaoFolhasMensais: flags.geracaoFolhasMensais,
    emailsPrazoRelatorioAtividades: flags.emailsPrazoRelatorioAtividades,
    abrirProcessosSeletivosAgendados: flags.abrirProcessosSeletivosAgendados,
    fecharProcessosSeletivosExpirados: flags.fecharProcessosSeletivosExpirados,
    limpezaNotificacoesAntigas: flags.limpezaNotificacoesAntigas,
    limpezaAuditoriaEmailsAntigas: flags.limpezaAuditoriaEmailsAntigas,
    anonimizarCandidatosLgpd: flags.anonimizarCandidatosLgpd,
  });
}
